import { NgModule } from '@angular/core';
import { AngularValidationsComponent } from './angular-validations.component';



@NgModule({
  declarations: [AngularValidationsComponent],
  imports: [
  ],
  exports: [AngularValidationsComponent]
})
export class AngularValidationsModule { }
